<template>
  <div class="divContainer pageManagePage">
    <div v-if="loading" v-loading="loading" class="fullContainer"></div>
    <div v-else class="pageManagePage__layout">
      <header class="pageManagePage__actionBar">
        <h1 class="pageManagePage__pageTitle">{{ pageHeadingTitle }}</h1>
        <div class="pageManagePage__actions">
          <button
            type="button"
            class="pageManagePage__btn pageManagePage__btn--ghost"
            @click="goBack"
          >
            取消
          </button>
          <button
            type="button"
            class="pageManagePage__btn pageManagePage__btn--primary"
            @click="submitForm"
          >
            保存
          </button>
        </div>
      </header>

      <main ref="pageScrollRef" class="pageManagePage__main">
        <el-form
          label-position="top"
          size="small"
          :model="ruleForm"
          :rules="rules"
          ref="ruleFormAll"
        >
          <el-card class="card">
            <div slot="header">
              <strong class="pageManageCard__title">页面基本信息</strong>
            </div>
            <div class="pageManageFormGrid pageManageFormGrid--basic">
              <el-form-item label="页面名称" prop="pageName">
                <el-input
                  v-model="ruleForm.pageName"
                  placeholder="请输入页面名称"
                  class="formItemStyle"
                ></el-input>
              </el-form-item>
              <el-form-item label="页面 Title" prop="pageTitle">
                <el-input
                  v-model="ruleForm.pageTitle"
                  placeholder="App 端识别的页面标识"
                  class="formItemStyle"
                ></el-input>
              </el-form-item>
              <el-form-item label="页面类型" prop="pageType">
                <el-select
                  @change="changePageType"
                  v-model="ruleForm.pageType"
                  placeholder="请选择页面类型"
                  class="formItemStyle"
                  popper-class="pageManageDropdown"
                >
                  <el-option
                    v-for="item in pageTypeOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-card>

          <el-card class="card">
            <div slot="header" class="cardHeader pageManageCard__header">
              <strong class="pageManageCard__title">页面组件</strong>
              <el-button
                type="primary"
                size="small"
                icon="el-icon-plus"
                class="pageManageBtnPrimary"
                :disabled="!ruleForm.pageType"
                @click="addComponent"
              >
                添加组件
              </el-button>
            </div>

            <p v-if="!ruleForm.pageType" class="pageManagePage__intro">
              请先选择页面类型。主信息流需绑定分类；页面组仅可绑定「主信息流」子页面（最多两层，不可成环）。
            </p>
            <p
              v-else-if="componentList.length > 0"
              class="pageManagePage__intro"
            >
              拖动组件顶栏可调整展示顺序；也可点左侧序号输入目标位置（右侧「删除」除外）。
            </p>

            <div
              v-if="componentList.length > 0"
              ref="componentListRef"
              class="pageManageComponentList"
            >
              <el-card
                class="resourcesComponent pageManageComponent"
                v-for="(item, index) in componentList"
                :key="item._key"
                :data-index="index"
              >
                <div slot="header" class="cardHeader smallFont pageManageComponent__header">
                  <div class="pageManageComponent__title">
                    <!-- 可输入序号：失焦/回车按目标位插入；mousedown.stop 避免 Sortable 抢焦点 -->
                    <input
                      class="pageManageComponent__orderInput link-font-mono"
                      type="text"
                      inputmode="numeric"
                      :value="index + 1"
                      :aria-label="'组件顺序 ' + (index + 1)"
                      :title="'第 ' + (index + 1) + ' 位（可输入）'"
                      @mousedown.stop
                      @click.stop
                      @keydown.enter.prevent="
                        commitComponentOrderInput(index, $event)
                      "
                      @blur="commitComponentOrderInput(index, $event)"
                    />
                    <i
                      class="el-icon-rank pageManageComponent__dragHint"
                      aria-hidden="true"
                    ></i>
                    <span>{{ componentTypeLabel }}</span>
                  </div>
                  <div class="pageManageComponent__actions">
                    <el-button
                      type="danger"
                      size="mini"
                      plain
                      @click="deleteComponent(index)"
                    >
                      删除
                    </el-button>
                  </div>
                </div>

                <div class="pageManageComponent__body">
                  <el-form
                    label-position="top"
                    size="small"
                    :model="componentList[index]"
                    :rules="rules"
                    ref="ruleForm"
                  >
                    <div class="pageManageFormGrid">
                      <el-form-item prop="title">
                        <template slot="label">
                          <span class="pageManageFieldLabel">
                            <span>标题</span>
                            <button
                              type="button"
                              class="pageManageLangLink"
                              @click="
                                openLanguageDialog(
                                  componentList[index].multiLanguage,
                                  componentList[index].title,
                                  index
                                )
                              "
                            >
                              <i
                                class="el-icon-s-flag"
                                aria-hidden="true"
                              ></i>
                              多语言
                            </button>
                          </span>
                        </template>
                        <el-input
                          placeholder="请输入标题"
                          v-model="componentList[index].title"
                          class="formItemStyle"
                        />
                      </el-form-item>

                      <el-form-item label="样式" prop="styleId">
                        <el-select
                          v-model="componentList[index].styleId"
                          :ref="'styleSelect' + index"
                          placeholder="选择样式"
                          class="formItemStyle pageManageStyleSelect"
                          popper-class="pageManageDropdown pageManageStyleDropdown"
                          @visible-change="
                            (visible) => onStyleDropdownVisible(visible, index)
                          "
                          @change="selectChange($event, index)"
                        >
                          <el-option
                            v-for="style in styleOption"
                            :key="style.id"
                            :label="style.name"
                            :value="style.id"
                          >
                            <div class="pageManageStyleOption">
                              <span
                                class="pageManageStyleOption__name"
                                :title="style.name"
                              >{{ style.name }}</span>
                              <span
                                v-if="style.displayMode"
                                class="pageManageStyleOption__mode"
                              >{{ style.displayMode }}</span>
                            </div>
                          </el-option>
                        </el-select>
                      </el-form-item>

                      <template v-if="ruleForm.pageType === '页面组'">
                        <el-form-item
                          label="选择页面"
                          prop="resourceId"
                        >
                          <el-select
                            v-if="!componentList[index].isMultiSelect"
                            :key="'page-single-' + index"
                            :ref="'pageSelect' + index"
                            v-model="componentList[index].resourceId"
                            placeholder="请选择主信息流页面"
                            class="formItemStyle pageManagePageSelect"
                            filterable
                            clearable
                            popper-class="pageManageDropdown pageManagePageDropdown"
                            @visible-change="
                              (visible) => onPageDropdownVisible(visible, index)
                            "
                            @change="
                              (value) => onPageResourceChange(value, index)
                            "
                          >
                            <el-option
                              v-for="page in pageGroupChildOptions"
                              :key="page.id"
                              :label="page.name"
                              :value="page.id"
                            >
                              <div class="pageManagePageOption">
                                <span
                                  class="pageManagePageOption__name"
                                  :title="page.name"
                                >{{ page.name }}</span>
                                <span class="pageManagePageOption__type">{{
                                  page.type
                                }}</span>
                              </div>
                            </el-option>
                          </el-select>
                          <el-select
                            v-else
                            :key="'page-multiple-' + index"
                            :ref="'pageSelect' + index"
                            v-model="componentList[index].resourceId"
                            placeholder="请选择主信息流页面（可多选）"
                            class="formItemStyle pageManagePageSelect"
                            multiple
                            filterable
                            clearable
                            popper-class="pageManageDropdown pageManagePageDropdown"
                            @visible-change="
                              (visible) => onPageDropdownVisible(visible, index)
                            "
                            @change="
                              (value) => onPageResourceChange(value, index)
                            "
                            v-sortable="{
                              list: componentList[index].resourceId,
                            }"
                          >
                            <el-option
                              v-for="page in pageGroupChildOptions"
                              :key="page.id + '-multi'"
                              :label="page.name"
                              :value="page.id"
                            >
                              <div class="pageManagePageOption">
                                <span
                                  class="pageManagePageOption__name"
                                  :title="page.name"
                                >{{ page.name }}</span>
                                <span class="pageManagePageOption__type">{{
                                  page.type
                                }}</span>
                              </div>
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </template>

                      <template v-else>
                        <el-form-item label="分类类型">
                          <el-select
                            v-model="componentList[index].categoryTypeKey"
                            placeholder="壁纸 / AI / 通用"
                            class="formItemStyle"
                            popper-class="pageManageDropdown"
                            @change="onCategoryTypeChange(index)"
                          >
                            <el-option
                              v-for="typeItem in feedTypeOptions"
                              :key="typeItem.categoryType"
                              :label="typeItem.name"
                              :value="typeItem.categoryType"
                            ></el-option>
                          </el-select>
                        </el-form-item>

                        <el-form-item label="选择分类" prop="resourceId">
                          <el-select
                            v-if="!componentList[index].isMultiSelect"
                            :key="'category-single-' + index"
                            v-model="componentList[index].resourceId"
                            placeholder="请先选分类类型"
                            class="formItemStyle"
                            filterable
                            clearable
                            popper-class="pageManageDropdown"
                            :disabled="isCategorySelectDisabled(index)"
                          >
                            <el-option
                              v-for="cat in categoriesForComponent(index)"
                              :key="cat.id"
                              :label="categoryOptionLabel(cat)"
                              :value="cat.id"
                            >
                              <div class="pageManageCategoryOption">
                                <span
                                  class="pageManageCategoryOption__name"
                                  :title="cat.name"
                                >{{ cat.name }}</span>
                                <span
                                  v-if="Number(cat.status) !== 1"
                                  class="pageManageCategoryOption__status"
                                >下线</span>
                              </div>
                            </el-option>
                          </el-select>
                          <el-select
                            v-else
                            :key="'category-multiple-' + index"
                            v-model="componentList[index].resourceId"
                            placeholder="请先选分类类型（可多选）"
                            class="formItemStyle"
                            multiple
                            filterable
                            clearable
                            popper-class="pageManageDropdown"
                            :disabled="isCategorySelectDisabled(index)"
                            v-sortable="{
                              list: componentList[index].resourceId,
                            }"
                          >
                            <el-option
                              v-for="cat in categoriesForComponent(index)"
                              :key="cat.id + '-multi'"
                              :label="categoryOptionLabel(cat)"
                              :value="cat.id"
                            >
                              <div class="pageManageCategoryOption">
                                <span
                                  class="pageManageCategoryOption__name"
                                  :title="cat.name"
                                >{{ cat.name }}</span>
                                <span
                                  v-if="Number(cat.status) !== 1"
                                  class="pageManageCategoryOption__status"
                                >下线</span>
                              </div>
                            </el-option>
                          </el-select>
                        </el-form-item>

                        <el-form-item label="展示数量" prop="showAmount">
                          <el-input
                            placeholder="该区块在 App 端最多展示几条"
                            v-model="componentList[index].showAmount"
                            type="number"
                            class="formItemStyle"
                          ></el-input>
                        </el-form-item>
                      </template>
                    </div>
                  </el-form>
                </div>
              </el-card>
            </div>
            <el-empty
              v-else
              :description="emptyDescription"
              :image-size="100"
            ></el-empty>
          </el-card>
        </el-form>
      </main>
    </div>

    <el-dialog
      :visible.sync="languageDialogVisible"
      width="640px"
      append-to-body
      custom-class="pageManageDialog"
      :close-on-click-modal="false"
      @close="onLanguageDialogClose"
    >
      <template slot="title">
        <div class="pageManageDialog__title">
          <i class="el-icon-s-flag" aria-hidden="true"></i>
          <span>多语言标题</span>
        </div>
      </template>
      <p class="pageManageDialog__hint">
        默认语言与上方「标题」同步；各 locale 留空时 App 端回退为默认标题。
      </p>
      <div class="pageManageLanguageGrid">
        <div
          v-for="item in languageList"
          :key="item.localeLanguageCode"
          class="pageManageLanguageGrid__item"
        >
          <label class="pageManageLanguageGrid__label">
            {{ item.localeLanguageCode }}
            <span class="pageManageLanguageGrid__sub">{{ item.chinese }}</span>
          </label>
          <el-input
            size="small"
            v-model="item.localeLanguageName"
            :placeholder="item.chinese"
          ></el-input>
        </div>
      </div>
      <div slot="footer" class="pageManageDialog__footer">
        <el-button size="small" @click="cancelLanguageDialog">取 消</el-button>
        <el-button type="primary" size="small" @click="confirmLanguageDialog">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  pageCreate,
  getInfoById,
  pageEdit,
  queryType,
} from "../../../api/pageManage";
import { getAllPage } from "../../../api/dataManage";
import {
  getAllStyle,
  getCategoryAll,
  getClassifyResourceType,
} from "../../../api/comment";
import Sortable from "sortablejs";
import {
  FEED_TYPE_OPTIONS,
  filterCategoriesByType,
  filterFeedCategories,
  mergeBoundCategoriesForComponent,
  resolveCategoryTypeKey,
  resolveFeedTypeOptionsFromApi,
  sortFeedTypeOptions,
} from "./pageManageCategoryHelper";
import {
  categoryOptionLabel,
  moveByOrderInput,
} from "./pageManageComponentOrder";
import {
  PAGE_TYPE_PAGE_GROUP,
  filterPageGroupChildOptions,
  guardPageGroupResourceChange,
  validatePageGroupComponents,
} from "./pageManagePageGroupHelper";
import "./pageManageSurfaces.css";

const DEFAULT_MULTI_LANGUAGE = [
  { localeLanguageCode: "en", chinese: "英文", localeLanguageName: "" },
  { localeLanguageCode: "ar", chinese: "阿拉伯语", localeLanguageName: "" },
  { localeLanguageCode: "pt-BR", chinese: "葡萄牙语", localeLanguageName: "" },
  { localeLanguageCode: "es", chinese: "西班牙语", localeLanguageName: "" },
  { localeLanguageCode: "de", chinese: "德语", localeLanguageName: "" },
  { localeLanguageCode: "fr", chinese: "法语", localeLanguageName: "" },
  { localeLanguageCode: "ja", chinese: "日语", localeLanguageName: "" },
  { localeLanguageCode: "ko", chinese: "韩语", localeLanguageName: "" },
  { localeLanguageCode: "zh-Hans", chinese: "简中", localeLanguageName: "" },
  { localeLanguageCode: "zh-Hant", chinese: "繁中", localeLanguageName: "" },
  { localeLanguageCode: "bn", chinese: "孟加拉语", localeLanguageName: "" },
  { localeLanguageCode: "hi", chinese: "印地语", localeLanguageName: "" },
  { localeLanguageCode: "in", chinese: "印尼语", localeLanguageName: "" },
  { localeLanguageCode: "id", chinese: "印尼语new", localeLanguageName: "" },
  { localeLanguageCode: "it", chinese: "意大利语", localeLanguageName: "" },
  { localeLanguageCode: "ms", chinese: "马来语", localeLanguageName: "" },
  { localeLanguageCode: "fa", chinese: "波斯语", localeLanguageName: "" },
  { localeLanguageCode: "ru", chinese: "俄语", localeLanguageName: "" },
  { localeLanguageCode: "fil", chinese: "菲律宾语", localeLanguageName: "" },
  { localeLanguageCode: "th", chinese: "泰语", localeLanguageName: "" },
  { localeLanguageCode: "vi", chinese: "越南语", localeLanguageName: "" },
  { localeLanguageCode: "zh", chinese: "中文安卓通用", localeLanguageName: "" },
  { localeLanguageCode: "pt", chinese: "葡萄牙语安卓通用", localeLanguageName: "" },
];

export default {
  name: "createOrEdit",
  data() {
    return {
      ruleForm: {
        pageName: "",
        pageType: "",
        pageTitle: "",
      },
      componentList: [],
      rules: {
        pageName: [
          { required: true, message: "页面名称不能为空", trigger: "blur" },
        ],
        pageTitle: [
          { required: true, message: "页面标题不能为空", trigger: "blur" },
        ],
        pageType: [
          { required: true, message: "页面类型不能为空", trigger: "change" },
        ],
        title: [{ required: true, message: "标题不能为空", trigger: "blur" }],
        styleId: [
          { required: true, message: "样式不能为空", trigger: "submit" },
        ],
        resourceId: [
          { required: true, message: "分类或页面不能为空", trigger: "submit" },
        ],
        showAmount: [
          { required: true, message: "展示数量不能为空", trigger: "blur" },
        ],
      },
      isCreate: true,
      loading: false,
      pageTypeOptions: [],
      id: "",
      styleOption: [],
      allPageOption: [],
      categoryOption: [],
      feedTypeOptions: sortFeedTypeOptions(FEED_TYPE_OPTIONS.slice()),
      languageDialogVisible: false,
      languageList: [],
      oldLanguageList: [],
      componentListIndex: 0,
      languageDialogConfirmed: false,
      componentSortable: null,
    };
  },
  computed: {
    pageHeadingTitle() {
      return this.isCreate ? "新建页面" : "编辑页面";
    },
    componentTypeLabel() {
      return this.ruleForm.pageType === "页面组" ? "页面组件" : "信息流组件";
    },
    emptyDescription() {
      if (!this.ruleForm.pageType) {
        return "请先选择页面类型";
      }
      return "暂无组件，点击「添加组件」";
    },
    pageGroupChildOptions() {
      return filterPageGroupChildOptions(this.allPageOption, {
        currentPageId: this.isCreate ? null : this.id,
      });
    },
    pageGroupSelectContext() {
      return {
        currentPageId: this.isCreate ? null : this.id,
        allPages: this.allPageOption,
      };
    },
  },
  created() {
    this.isCreate = this.$route.path.indexOf("edit") === -1;
    this.getPageType();
    this.getAllStyleOption();
    this.loadFeedTypeOptions();
    if (!this.isCreate) {
      this.getRuleForm();
    } else {
      this.getCategoryAllOption();
      this.getPageAllOption();
    }
  },
  mounted() {
    this.$nextTick(() => this.initComponentSortable());
  },
  updated() {
    this.$nextTick(() => this.initComponentSortable());
  },
  beforeDestroy() {
    this.destroyComponentSortable();
  },
  methods: {
    categoriesForComponent(index) {
      const component = this.componentList[index];
      const pool = mergeBoundCategoriesForComponent(this.categoryOption, component);
      return filterCategoriesByType(
        pool,
        component && component.categoryTypeKey
      );
    },
    isCategorySelectDisabled(index) {
      const component = this.componentList[index];
      if (!component) {
        return true;
      }
      const hasBound =
        (Array.isArray(component.resourceId) && component.resourceId.length > 0) ||
        (component.resourceId !== null &&
          component.resourceId !== undefined &&
          component.resourceId !== "");
      // 编辑回显：已有绑定时不禁用；新建仍需先选分类类型
      if (hasBound) {
        return false;
      }
      return !component.categoryTypeKey;
    },
    loadFeedTypeOptions() {
      getClassifyResourceType()
        .then((res) => {
          this.feedTypeOptions = resolveFeedTypeOptionsFromApi(res);
        })
        .catch(() => {
          this.feedTypeOptions = sortFeedTypeOptions(FEED_TYPE_OPTIONS.slice());
        });
    },
    initComponentSortable() {
      const el = this.$refs.componentListRef;
      if (!el || this.componentList.length < 2) {
        this.destroyComponentSortable();
        return;
      }
      if (this.componentSortable) {
        return;
      }
      const scrollEl = this.resolvePageScrollEl();
      this.componentSortable = Sortable.create(el, {
        handle: ".pageManageComponent__header",
        // 删除区与序号输入不启动拖拽；preventOnFilter=false 让输入框能聚焦
        filter: ".pageManageComponent__actions, .pageManageComponent__orderInput",
        preventOnFilter: false,
        animation: 160,
        ghostClass: "pageManageComponent--ghost",
        scroll: scrollEl || true,
        bubbleScroll: true,
        scrollSensitivity: 100,
        scrollSpeed: 18,
        forceAutoScrollFallback: true,
        onEnd: (evt) => {
          const { oldIndex, newIndex } = evt;
          if (oldIndex === newIndex || oldIndex == null || newIndex == null) {
            return;
          }
          const moved = this.componentList.splice(oldIndex, 1)[0];
          this.componentList.splice(newIndex, 0, moved);
          this.sortList();
        },
      });
    },
    resolvePageScrollEl() {
      if (this.$refs.pageScrollRef) {
        return this.$refs.pageScrollRef;
      }
      return document.querySelector(".layoutMain");
    },
    onStyleDropdownVisible(visible, index) {
      if (!visible) {
        return;
      }
      this.$nextTick(() => {
        const ref = this.$refs["styleSelect" + index];
        const select = Array.isArray(ref) ? ref[0] : ref;
        if (!select || !select.$refs.popper) {
          return;
        }
        const width = Math.ceil(select.$el.getBoundingClientRect().width);
        const popperEl = select.$refs.popper.$el;
        popperEl.style.minWidth = `${width}px`;
        popperEl.style.width = `${width}px`;
      });
    },
    onPageDropdownVisible(visible, index) {
      if (!visible) {
        return;
      }
      this.$nextTick(() => {
        const ref = this.$refs["pageSelect" + index];
        const select = Array.isArray(ref) ? ref[0] : ref;
        if (!select || !select.$refs.popper) {
          return;
        }
        const width = Math.ceil(select.$el.getBoundingClientRect().width);
        const popperEl = select.$refs.popper.$el;
        popperEl.style.minWidth = `${width}px`;
        popperEl.style.width = `${width}px`;
      });
    },
    onPageResourceChange(nextValue, index) {
      if (this.ruleForm.pageType !== PAGE_TYPE_PAGE_GROUP) {
        return;
      }
      const component = this.componentList[index];
      if (!component) {
        return;
      }
      const previous =
        component._lastValidResourceId !== undefined
          ? component._lastValidResourceId
          : component.isMultiSelect
          ? []
          : "";
      const guarded = guardPageGroupResourceChange(
        nextValue,
        previous,
        this.pageGroupSelectContext
      );
      if (!guarded.ok) {
        this.$message({ type: "warning", message: guarded.message });
        this.$set(component, "resourceId", guarded.resourceId);
        return;
      }
      this.$set(component, "_lastValidResourceId", guarded.resourceId);
    },
    rememberPageResourceSnapshots() {
      if (this.ruleForm.pageType !== PAGE_TYPE_PAGE_GROUP) {
        return;
      }
      this.componentList.forEach((component) => {
        this.$set(component, "_lastValidResourceId", component.resourceId);
      });
    },
    destroyComponentSortable() {
      if (this.componentSortable) {
        this.componentSortable.destroy();
        this.componentSortable = null;
      }
    },
    syncComponentCategoryType(index) {
      const component = this.componentList[index];
      if (!component || this.ruleForm.pageType === "页面组") {
        return;
      }
      const typeKey = resolveCategoryTypeKey(
        this.categoryOption,
        component.resourceId,
        component.categoryTypeKey
      );
      this.$set(component, "categoryTypeKey", typeKey);
    },
    onCategoryTypeChange(index) {
      const component = this.componentList[index];
      if (!component) {
        return;
      }
      if (component.isMultiSelect) {
        this.$set(component, "resourceId", []);
      } else {
        this.$set(component, "resourceId", "");
      }
    },
    selectChange(value, index) {
      this.isMultipleChange(value, index);
    },
    isMultipleChange(styleId, index) {
      // Element UI @change 传入的就是新 styleId，直接用形参，避免再读 model 产生时序歧义
      const id = styleId;
      if (id || id === 0) {
        this.styleOption.forEach((element) => {
          if (element.id === id) {
            if (element.displayMode === "资源展示") {
              this.$set(this.componentList[index], "isMultiSelect", false);
              const current = this.componentList[index].resourceId;
              // [] 时 current[0] 为 undefined，单选需兜底 "" 才能正确清空 el-select
              let keep = "";
              if (current !== null && current !== undefined && current !== "") {
                if (Array.isArray(current)) {
                  const first = current[0];
                  keep =
                    first !== null && first !== undefined && first !== ""
                      ? first
                      : "";
                } else {
                  keep = current;
                }
              }
              this.$nextTick(() => {
                this.$set(this.componentList[index], "resourceId", keep);
              });
              return;
            }
            const current = this.componentList[index].resourceId;
            const keep = Array.isArray(current)
              ? current.slice()
              : current !== null && current !== undefined && current !== ""
              ? [current]
              : [];
            this.$set(this.componentList[index], "resourceId", keep);
            this.$set(this.componentList[index], "isMultiSelect", true);
          }
        });
      } else {
        const current = this.componentList[index].resourceId;
        const nextVal = Array.isArray(current)
          ? current.slice()
          : current !== null && current !== undefined && current !== ""
          ? [current]
          : [];
        this.$set(this.componentList[index], "resourceId", nextVal);
        this.$nextTick(() => {
          this.$set(this.componentList[index], "isMultiSelect", true);
        });
      }
    },
    isMultiple(index) {
      const component = this.componentList[index];
      const id = component.styleId;
      const resourceId = component.resourceId;
      const singleValue = Array.isArray(resourceId)
        ? resourceId[0] !== null &&
          resourceId[0] !== undefined &&
          resourceId[0] !== ""
          ? resourceId[0]
          : ""
        : resourceId;

      // 后端下发的组件对象未声明 isMultiSelect，必须用 $set 才能触发 Vue 2 响应式
      if (id || id === 0) {
        let matched = false;
        this.styleOption.forEach((k) => {
          if (k.id === id) {
            matched = true;
            if (k.displayMode === "资源展示") {
              this.$set(component, "resourceId", singleValue);
              this.$set(component, "isMultiSelect", false);
            } else {
              this.$set(component, "isMultiSelect", true);
            }
          }
        });
        if (!matched) {
          this.$set(component, "isMultiSelect", Array.isArray(resourceId));
        }
      } else {
        this.$set(component, "isMultiSelect", Array.isArray(resourceId));
      }
      if (!component._key) {
        this.$set(component, "_key", "legacy-" + index + "-" + component.sequence);
      }
      this.syncComponentCategoryType(index);
    },
    openLanguageDialog(languageList, title, index) {
      languageList[0].localeLanguageName = title;
      this.languageList = languageList;
      this.oldLanguageList = JSON.parse(JSON.stringify(languageList));
      this.componentListIndex = index;
      this.languageDialogConfirmed = false;
      this.languageDialogVisible = true;
    },
    cancelLanguageDialog() {
      this.languageDialogVisible = false;
    },
    confirmLanguageDialog() {
      this.languageDialogConfirmed = true;
      this.languageDialogVisible = false;
    },
    onLanguageDialogClose() {
      if (!this.languageDialogConfirmed) {
        const component = this.componentList[this.componentListIndex];
        if (component) {
          component.multiLanguage = JSON.parse(
            JSON.stringify(this.oldLanguageList)
          );
        }
      }
      this.languageDialogConfirmed = false;
    },
    addComponent() {
      if (!this.ruleForm.pageType) {
        this.$message({
          type: "warning",
          message: "请先选择页面类型",
        });
        return;
      }
      this.destroyComponentSortable();
      this.componentList.push({
        _key: "c-" + Date.now() + "-" + Math.random().toString(36).slice(2, 7),
        sequence: String(this.componentList.length + 1),
        title: "",
        styleId: "",
        resourceId: "",
        _lastValidResourceId: "",
        showAmount: "",
        categoryTypeKey: null,
        isMultiSelect: false,
        multiLanguage: JSON.parse(JSON.stringify(DEFAULT_MULTI_LANGUAGE)),
      });
      this.$nextTick(() => this.initComponentSortable());
    },
    deleteComponent(index) {
      this.destroyComponentSortable();
      this.componentList.splice(index, 1);
      this.sortList();
      this.$nextTick(() => this.initComponentSortable());
    },
    sortList() {
      this.componentList.forEach((e, i) => {
        e.sequence = String(i + 1);
      });
    },
    /**
     * 把当前组件挪到运营输入的 1-based 位置；非法数字提示并还原显示。
     * 与拖动共用 splice 重排，落库顺序仍由数组下标 → sequence。
     */
    commitComponentOrderInput(fromIndex, event) {
      const input = event && event.target;
      const raw = input ? String(input.value || "").trim() : "";
      const result = moveByOrderInput(this.componentList, fromIndex, raw);
      if (!result.ok) {
        if (input) {
          input.value = result.restore;
        }
        if (result.message) {
          this.$message.warning(result.message);
        }
        return;
      }
      this.destroyComponentSortable();
      this.componentList = result.nextList;
      this.sortList();
      this.$nextTick(() => this.initComponentSortable());
    },
    categoryOptionLabel,
    submitForm() {
      this.$refs["ruleFormAll"].validate((valid) => {
        if (!valid) {
          this.$message({
            message: "页面基本信息模块，提交信息不完整",
            type: "info",
          });
          return false;
        }
        const array = this.$refs["ruleForm"];
        if (array === undefined) {
          this.$message({
            type: "info",
            message: "请至少添加一个页面组件",
          });
          return;
        }
        let flag = true;
        array.forEach((item) => {
          item.validate((itemValid) => {
            if (!itemValid) {
              flag = false;
            }
          });
        });
        if (!flag) {
          this.$message({
            message: "页面组件信息不完善",
            type: "info",
          });
          return;
        }
        if (this.ruleForm.pageType === PAGE_TYPE_PAGE_GROUP) {
          const pageGroupCheck = validatePageGroupComponents(
            this.componentList,
            this.pageGroupSelectContext
          );
          if (!pageGroupCheck.valid) {
            this.$message({
              type: "warning",
              message: pageGroupCheck.message,
            });
            return;
          }
        }
        this.componentList.forEach((e) => {
          e.styleId = Number(e.styleId);
          e.showAmount = Number(e.showAmount);
          e.sequence = Number(e.sequence);
          if (typeof e.resourceId !== "object") {
            e.resourceId = [parseInt(e.resourceId, 10)];
          } else {
            e.resourceId = e.resourceId.map((ele) => parseInt(ele, 10));
          }
        });
        if (this.isCreate) {
          pageCreate(this.ruleForm, this.componentList).then((res) => {
            if (res.success) {
              this.$message({ message: "新建成功", type: "success" });
              this.$router.push("/collection/page/list");
            }
          });
        } else {
          pageEdit(this.id, this.ruleForm, this.componentList).then((res) => {
            if (res.success) {
              this.$message({ message: "编辑成功", type: "success" });
              this.$router.push("/collection/page/list");
            }
          });
        }
      });
    },
    getRuleForm() {
      this.loading = true;
      getInfoById({ id: this.$route.params.id })
        .then((res) => {
          if (!res.success) {
            return Promise.resolve();
          }
          this.ruleForm.pageType = res.data.type;
          this.ruleForm.pageName = res.data.name;
          this.componentList = res.data.resourceComponentVOList || [];
          this.id = res.data.id;
          this.ruleForm.pageTitle = res.data.title;
          return this.getCategoryAllOption().then(() => {
            this.componentList.forEach((element, index) => {
              this.isMultiple(index);
            });
            this.rememberPageResourceSnapshots();
            this.$nextTick(() => this.initComponentSortable());
          });
        })
        .finally(() => {
          this.loading = false;
        });
      this.getPageAllOption();
    },
    getPageType() {
      queryType().then((res) => {
        if (res.success) {
          this.pageTypeOptions = this.$sortSelect(res.data || []);
        }
      });
    },
    getAllStyleOption() {
      getAllStyle().then((res) => {
        if (res.success) {
          this.styleOption = this.$sortSelect(res.data);
        }
      });
    },
    getCategoryAllOption() {
      return getCategoryAll().then((res) => {
        if (res.success) {
          this.categoryOption = this.$sortSelect(filterFeedCategories(res.data));
        }
        return res;
      });
    },
    getPageAllOption() {
      getAllPage().then((res) => {
        if (res.success) {
          this.allPageOption = this.$sortSelect(res.data || []);
          this.rememberPageResourceSnapshots();
        }
      });
    },
    goBack() {
      this.$router.push("/collection/page/list");
    },
    changePageType() {},
  },
  watch: {
    "ruleForm.pageType"(newVal, oldVal) {
      if (!oldVal && newVal) {
        return;
      }
      if (oldVal && newVal !== oldVal) {
        this.destroyComponentSortable();
        this.componentList = [];
      }
    },
    "componentList.length"() {
      this.$nextTick(() => {
        this.destroyComponentSortable();
        this.initComponentSortable();
      });
    },
  },
  directives: {
    sortable: {
      inserted: (el, binding) => {
        const span = el.getElementsByTagName("span")[0];
        if (!span) {
          return;
        }
        new Sortable(span, {
          onEnd: (evt) => {
            const list = binding.value.list;
            const targetRow = list.splice(evt.oldIndex, 1)[0];
            list.splice(evt.newIndex, 0, targetRow);
          },
        });
      },
    },
  },
};
</script>

<style scoped>
.divContainer {
  height: 100%;
}

.fullContainer {
  width: 100%;
  height: 100%;
}

.cardHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.smallFont {
  font-size: 12px;
}

::v-deep .el-select__tags-text {
  cursor: all-scroll;
  user-select: none;
}
</style>
